import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchPageContent } from '@client/connectivity/api.cms';
import { loadFundraiserDonations } from '@client/redux/donation/donationReducer';
import { loadEvents } from '@client/redux/event/eventReducer';
import {
  loadFundraiser,
  loadFundraiserComment,
  loadFundraiserTypes,
} from '@client/redux/fundraiser/fundraiserActions';

export const DUCK_INDIVIDUAL_FUNDRAISER_KEY =
  'duckIndividualFundraiserPageReducer';

const SET_INDIVIDUAL_FUNDRAISER_ERROR = 'SET_INDIVIDUAL_FUNDRAISER_ERROR';
const LOAD_INDIVIDUAL_FUNDRAISER_CMS = 'LOAD_INDIVIDUAL_FUNDRAISER_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_INDIVIDUAL_FUNDRAISER_CMS: {
      return state.merge({
        pageData: fromJS(action.payload),
        errorMessage: '',
      });
    }
    case SET_INDIVIDUAL_FUNDRAISER_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadIndividualFundraiserCms() {
  return function (dispatch) {
    return fetchPageContent('individualFundraiserPage').then((response) => {
      return dispatch({
        type: LOAD_INDIVIDUAL_FUNDRAISER_CMS,
        payload: response,
      });
    });
  };
}

export function loadIndividualFundraiserPageData(fundraiserSlug, searchParams) {
  return function (dispatch) {
    const ifPageDataPromises = [
      dispatch(loadIndividualFundraiserCms()),
      dispatch(loadFundraiser(fundraiserSlug)),
      dispatch(loadFundraiserTypes(fundraiserSlug)),
      dispatch(loadFundraiserComment(fundraiserSlug)),
      dispatch(loadFundraiserDonations(fundraiserSlug)),
      dispatch(loadEvents()),
    ];
    return Promise.all(ifPageDataPromises);
  };
}

/* SELECTORS */
export const selectIndividualFundraiserPageData = (state) => {
  return valIn(state[DUCK_INDIVIDUAL_FUNDRAISER_KEY], 'pageData');
};
